var React = require('react');

function Cancel (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m24.6454 9.20245c-.2678-.26993-.702-.26993-.9698 0l-5.8185 5.86505-5.8185-5.86505c-.2677-.26993-.7019-.26993-.9697 0l-1.9395 1.95505c-.26779.2699-.26779.7075 0 .9775l5.8185 5.865-5.8185 5.865c-.26779.27-.26779.7076 0 .9775l1.9395 1.9551c.2678.2699.702.2699.9697 0l5.8185-5.8651 5.8185 5.8651c.2678.2699.702.2699.9698 0l1.9395-1.9551c.2677-.2699.2677-.7075 0-.9775l-5.8185-5.865 5.8185-5.865c.2678-.27.2677-.7076 0-.9775z","fill":"#fff","fillRule":"evenodd"}));
}

Cancel.defaultProps = {"fill":"none","height":"36","viewBox":"0 0 36 36","width":"36"};

module.exports = Cancel;

Cancel.default = Cancel;
